/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Already_Issued_On_MisaInputs */

const vi_einvoice_err_already_issued_on_misa = /** @type {(inputs: Einvoice_Err_Already_Issued_On_MisaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nháp cũ đã được ký thành hóa đơn trên MISA nên không xoá được. Hãy kiểm tra lại trên MISA.`)
};

/**

* @param {Einvoice_Err_Already_Issued_On_MisaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_already_issued_on_misa = /** @type {((inputs?: Einvoice_Err_Already_Issued_On_MisaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Already_Issued_On_MisaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_already_issued_on_misa(inputs)
});